export const CALLBACK_URL = 'callbackURL';
export const CALLBACK_PATH = 'callbackPath';
